// Punto único de composición del tema.
import { createViewer } from './viewer.js';
import { initDonation } from './donate.js';
import { initContactForm, initEventForms } from './forms.js';
import { initVideo, initGallery } from './media.js';
import { initNav, initDock, initCounters, initMagnetic, initYear } from './page.js';

const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

createViewer({ reduceMotion });

// Lista de protegidos: se arma con las historias marcadas como protegido.
// Cada fila se despliega con su historia y su foto.
const petsList = document.querySelector('[data-pets]');
if (petsList) {
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
  document.querySelectorAll('.stories .story[data-pet="true"]').forEach(story => {
    const name = story.dataset.name;
    const avatar = new URL(story.dataset.avatar, document.baseURI).href;
    const paragraphs = (story.dataset.petStory || '').split(/\n+/).map(s => s.trim()).filter(Boolean);

    const li = el('li');
    const d = el('details', 'pet-d');
    d.name = 'protegidos';
    d.style.setProperty('--ph', `url("${avatar}")`);

    const summary = el('summary', 'pet');
    const thumb = el('span', 'pet__thumb'); thumb.setAttribute('aria-hidden', 'true');
    const go = el('span', 'pet__go', 'Abrir'); go.setAttribute('aria-hidden', 'true');
    summary.append(thumb, el('span', 'pet__name', name), el('span', 'pet__meta', story.dataset.petMeta || ''), go);

    const body = el('div', 'pet__body');
    const photo = el('div', 'pet__photo'); photo.setAttribute('role', 'img'); photo.setAttribute('aria-label', `Foto de ${name}`);
    const text = el('div', 'pet__text');
    if (paragraphs[0] && /^lorem ipsum/i.test(paragraphs[0])) text.append(el('span', 'pet__sample', 'Texto de ejemplo'));
    paragraphs.forEach(p => text.append(el('p', '', p)));
    body.append(photo, text);

    d.append(summary, body);
    li.append(d);
    petsList.append(li);
  });
}

initDonation();
initVideo();
initGallery();
initContactForm();
initEventForms();
initNav();
initDock();
initCounters(reduceMotion);
initMagnetic(reduceMotion);
initYear();
